import { render, staticRenderFns } from "./QuizResults.vue?vue&type=template&id=6035710e&scoped=true"
import script from "./QuizResults.vue?vue&type=script&lang=js"
export * from "./QuizResults.vue?vue&type=script&lang=js"
import style0 from "./QuizResults.vue?vue&type=style&index=0&id=6035710e&prod&scoped=true&lang=css"
import style1 from "./QuizResults.vue?vue&type=style&index=1&id=6035710e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6035710e",
  null
  
)

export default component.exports